// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"style_footerContainer__3sudO","mainContainer":"style_mainContainer__1DeVf"};